var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg6":"","xs12":""}},_vm._l((_vm.settingComponents),function(c,i){return _c(c,{key:i,tag:"component"})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }